module.exports = __webpack_public_path__ + "static/img/5.868c3b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/zh/5.png
// module id = b1u5
// module chunks = 0